// extracted by mini-css-extract-plugin
export default {"oneride":"Rideitem_oneride__GFCkV","image":"Rideitem_image__CcsK7","fBlock":"Rideitem_fBlock__qk0Yk","middle":"Rideitem_middle__eLQu8"};